import styled, { css } from 'styled-components';

import { ThemeMode } from '@/helpers/enums';

import { device } from '@/styles/helpers';

export const ScSelectWallet = styled.div<{ mode?: ThemeMode }>`
  display: flex;
  flex-direction: column;
  gap: 48px;

  & > form input {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.16px;
  }

  & > footer {
    position: sticky;
    left: 0;
    bottom: 0;
    background-color: ${({ theme, mode }) =>
      mode === ThemeMode.Dark ? theme.blackColor : theme.whiteColor};
    z-index: 10;

    @media (${device.mobileS}) {
      min-width: 100vw;
      padding: 0 16px;
      margin-left: -16px;

      &::before {
        content: '';
        position: absolute;
        width: 100%;
        left: 0;
        background-color: ${({ theme }) => theme.blackColor};
        top: -24px;
        height: 24px;
      }
    }
  }
`;

export const ScPaymentMethods = styled.div<{ mode?: ThemeMode }>`
  display: grid;
  gap: 16px;

  & .title {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.02em;
    color: ${({ theme }) => theme.blackColor};
    text-transform: uppercase;

    @media (${device.mobileS}) {
      color: ${({ theme }) => theme.whiteColor};
    }
  }

  .methods {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .title {
      font-size: 22px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 0.44px;
      text-transform: uppercase;
      margin-bottom: 8px;

      @media (${device.mobileS}) {
        font-size: 20px;
      }
    }
  }
`;

export const ScPaymentMethodCard = styled.div<{
  isActive?: boolean;
  mode?: ThemeMode;
}>`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  min-height: 56px;
  transition: 0.4s;
  position: relative;
  background-color: ${({ theme, mode }) =>
    mode === ThemeMode.Dark ? theme.grayLightColor : theme.gray1Color};
  border: 2px solid transparent;
  gap: 8px;

  & > .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 4px 16px 4px 4px;
    cursor: pointer;

    .brand {
      height: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 4px;
      align-items: center;
      background-color: ${({ theme }) => theme.whiteColor};
      height: 48px;
      width: 100%;
      max-width: 120px;
      padding: 4px 8px;
      border-radius: 12px;

      .brand-logo {
        object-fit: contain;
        @media (${device.mobileS}) {
          width: 100%;
        }
      }

      span {
        font-size: 12px;
        font-weight: 700;
        line-height: 18px;
        color: ${({ theme }) => theme.blackColor};
      }
    }

    .prev-method {
      height: 70px;
      padding: 4px;
    }

    .rules {
      display: flex;
      align-items: center;
      gap: 16px;
      text-align: end;

      .info-container {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
      }

      span {
        font-size: 14px;
        line-height: 20px;
        color: ${({ theme }) => theme.blackLightColor};
        transition: color 0.2s ease-in-out;
      }

      & > i {
        color: ${({ theme }) => theme.color2};
        transform: rotate(90deg);
        flex-shrink: 0;
        transition: transform 0.2s ease-in-out;
      }
    }
  }

  ${({ isActive, mode }) =>
    isActive &&
    css`
      border-color: ${({ theme }) =>
        mode === ThemeMode.Dark ? theme.grayColor : theme.grayMegaLightColor};

      & > .info .rules {
        & > i {
          transform: rotate(-90deg);
        }
      }
    `}

  @media (hover: hover) {
    &:hover {
      .rules {
        span {
          color: ${({ theme }) => theme.blackColor};
        }

        & > i {
          transform: ${({ isActive }) => !isActive && 'translateY(2px)'};

          color: ${({ theme }) => theme.blackColor};
        }
      }
    }
  }
`;

export const ScDepositStepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: auto;

  ${ScSelectWallet},
  ${ScPaymentMethods} {
    flex: auto;

    & > footer {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: auto;

      & > button {
        width: 100%;
        max-width: 280px;

        .initial {
          text-transform: none;
          margin-left: 8px;
        }

        @media (${device.mobileS}) {
          max-width: 100%;
        }
      }
    }
  }
`;
